/**
 * GripReadoutGhost — the cursor-anchored coordinate readout during grip drags
 * (Faz 11.6, OCS B3 readout parity): the drag's live constrained world point
 * rides the pointer as a small mono balloon (the yellow sphere ghost's
 * replacement). Pure DOM, pointer-transparent, rendered outside the R3F
 * canvas (Viewport overlay slot).
 */

import { Box } from '@chakra-ui/react';
import { useGripDragStore } from '../../state/useGripDragStore';

const CURSOR_OFFSET = 18;

export function GripReadoutGhost() {
    const active = useGripDragStore((s) => s.active);
    const client = useGripDragStore((s) => s.client);
    const world = useGripDragStore((s) => s.world);

    if (!active || !client || !world) return null;

    return (
        <Box
            position="fixed"
            // Runtime position of a cursor-anchored balloon — the only inline
            // style allowed (dynamic coordinates, no static styling here).
            left={`${client.x + CURSOR_OFFSET}px`}
            top={`${client.y + CURSOR_OFFSET}px`}
            bg="bg.panel"
            border="1px solid"
            borderColor="border.base"
            borderRadius="sm"
            px={2}
            py={0.5}
            fontFamily="mono"
            fontSize="10px"
            color="text.primary"
            pointerEvents="none"
            zIndex={40}
            whiteSpace="nowrap"
        >
            {world[0].toFixed(2)}, {world[1].toFixed(2)}
        </Box>
    );
}

export default GripReadoutGhost;
